/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import BBDO_Form from '../modules/form'

export default class Account {

	constructor() {
		this.initEvents();
	}

	initEvents() {
		//add required to password fields when one of them is filled in.
		$('.password-form input').on('keyup', function (e) {
			let required = false;
			$('.password-form input').each(function (e) {
				if ($(this).val() !== "") {
					return required = true;
				}
			});

			if (required) {
				return $('.password-form input').prop('required', true);
			}
		});


		//click function for edit button
		$('.js-edit-account').on('click', function (e) {
			e.preventDefault();
			$(this).hide();

			const form = $(this).parents('form:first');
			const forminput = form.find('input');

			form.find('.submit').show();
			form.find('input').removeAttr('disabled');
			form.find('button').removeAttr('disabled');
			form.find('.input-float').removeClass('disabled').parent().find(' > span').hide();
			return form.find('.password tr').removeClass('disabled').find('input').val('');
		});

		//click function for edit button
		$('.js-cancel-edit-account').on('click', function (e) {
			e.preventDefault();
			$(this).hide();
			const form = $(this).parents('form:first');
			form.find('.submit').hide();
			form.find('.js-edit-account:first').show();
			form.find('.submit').find('span').show();
			form.find('input').attr('disabled', 'disabled');
			form.find('button').attr('disabled', 'disabled');
			form.find('.input-float').addClass('disabled').parent().find(' > span').show();
			form.find('.password tr:not(:first)').addClass('disabled');
			return form.find('.password tr:first').find('input').val('current_password');
		});

		//add submit handler to form module
		return $('.account-form').each((index, element) => {
			const handler = function (element) {
				element.find('.js-edit-account:first').show();
				element.find('.submit').hide();
				element.find('input').attr('disabled', 'disabled');
				element.find('button').attr('disabled', 'disabled');
				element.find('.input-float').addClass('disabled').parent().find(' > span').show();
				element.find('.password tr:not(:first)').addClass('disabled');
				element.find('.password tr:first').find('input').val('current_password');

				//change gender label in table
				const radio = $('.account-form input[type="radio"]:checked');
				const label = radio.next().text();
				$('.gender').text(label);

				//change dob label in table
				let dob = "";
				$(".dob .select__placeholder[data-value!='0']").each(function (key, value) {
					return dob += $(this).find('span').html() + ' ';
				});

				dob = dob.substring(0, dob.length - 1);
				return $('.dob.text').text(dob);
			};


			return new BBDO_Form($(element), handler);
		});
	}
}
